import classes from './EmployeesTableListItem.module.css';
import DefaultIcon from '../../../../assets/default_photo.png'

import Image from '../../../UI/ImageHolder/Image'
import React from 'react';
import {getEmployeeFioItemWithMatch} from "../../../../services/Employees/employeesService";

const EmployeesTableListItem = (props) => {

    let employeeFioItem = getEmployeeFioItemWithMatch(props.data.lastName + ' ' + props.data.firstName + ' ' + (props.data.middleName ? ' ' + props.data.middleName : ''), props.searchEmployee)

    const getFormattedPhoneNumber = (contact, contactIndex) => {
        return <span key={contactIndex}>
                    <div style={{wordWrap: 'break-word'}}>
                        {contact.phoneNumber.substr(0, 4)} ({contact.phoneNumber.substr(4, 2)}) {contact.phoneNumber.substr(6, 3)}-
                        {contact.phoneNumber.substr(9, 2)}-{contact.phoneNumber.substr(11, 2)}
                    </div>
                </span>
    }

    return (
        <div className={classes.container} onClick={props.clicked}>
            <div>
                <Image size={75} src={props.data.photoLink} fallbackSrc={DefaultIcon} radius={100} />
            </div>
            <div className={classes.employeeDataContainer}>
                <div className={classes.FIO}>{employeeFioItem}</div>
                {props.data.jobPositions[0].jobPosition &&
                    <div style={{display: "flex", justifyContent: "space-between", width: "50%"}}>
                        <div className={classes.jobPositionsContainer} style={{marginRight: 10}}>
                            <div className={classes.placeholderTitle}>Должность</div>
                            {props.data.jobPositions.map((el, index) =>
                                <span key={index}>
                                    {el.jobPosition
                                        && <div style={{wordWrap: 'break-word'}}>{(index === props.data.jobPositions.length) ? el.jobPosition + ', ' : el.jobPosition}</div>}
                                </span>
                            )}
                        </div>
                        {props.data.jobPositions.map((el) =>
                            <div className={classes.jobPositionsContainer}>
                                {el.contacts.length > 0 && <div className={classes.placeholderTitle}>Телефон</div>}
                                {el.contacts.map((contact, contactIndex) =>
                                    getFormattedPhoneNumber(contact, contactIndex)
                                )}
                            </div>
                        )}
                    </div>}
            </div>
            <div className={classes.employeeDataMobileContainer}>
                <div className={classes.FIO}>{employeeFioItem}</div>
                <div>
                    {props.data.jobPositions.map((el, index) =>
                        <div>
                            <span key={index}>
                                {(el.jobPosition)
                                    && <React.Fragment>{(index === props.data.jobPositions.length) ? el.jobPosition + ', ' : el.jobPosition}</React.Fragment>}
                            </span>
                            {el.contacts.map((contact, contactIndex) =>
                                getFormattedPhoneNumber(contact, contactIndex)
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default EmployeesTableListItem;